module.exports = __webpack_public_path__ + "img/icon-upload.9fa620b8.svg";